/**
 * The client name shown to the recipient: the profile name when the profile opts into its own name,
 * otherwise the client company. Mirrors the banner beside the logo, so event copy stays in sync.
 */
export const resolveClientDisplayName = (client, clientProfile) =>
  clientProfile?.is_use_profile_name ? clientProfile.name : client?.company;
